import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoimpedimentos(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoimpedimentos/FIND_IMPEDIMENTOS':
      case '@operacaoimpedimentos/UPDATE_IMPEDIMENTOS':
      case '@operacaoimpedimentos/DELETE_IMPEDIMENTOS':
      case '@operacaoimpedimentos/STORE_IMPEDIMENTOS':
      case '@operacaoimpedimentos/IMPEDIMENTOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoimpedimentos/SUCCESS_REMOVE':
      case '@operacaoimpedimentos/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoimpedimentos/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoimpedimentos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoimpedimentos/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoimpedimentos;
        break;
      }

      case '@operacaoimpedimentos/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
